import NotInformation from '../../../../../components/NotInformation';
import routes from '../../../../../Routes/routes';
import CustomExpandableTable from '../../../../../components/table/CustomExpandableTable';
import { permissionObj } from '../../../../../Helpers/permission';
import DishesTableApp from "../Functionality/DishesTableApp";
import DisplayView from "../../../../../components/DisplayView";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import {VIEW_TYPE} from "../../../../../enums/ViewType";
import CustomButtonLink from '../../../../../components/buttons/CustomButtonLink';

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 */

const DishesTable = ({
    view,
    setView,
    setBodyForExport,
    modified,
    setModified,
    selectedList,
    setSelectedList,
    isAllChecked,
    setIsAllChecked,
    option
 }) => {
    const {
        t,
        columns,
        DEV,
        permission,
        rowsPerPage,
        searchResults,
        setSearchResults,
        searchElement,
        setSearchElement,
        search,
        setSearch,
        setSimpleSearch,
        handleDeleteAll,
        handleCheckboxChange,
        renderOptionsMenu,
        renderExpandedRow,
        handleRowExpand,
        pagination
    } = DishesTableApp({
        view,
        setBodyForExport,
        modified,
        setModified,
        selectedList,
        setSelectedList,
        isAllChecked,
        setIsAllChecked,
        option
    });


    return (
        <>
            <div className='d-flex'>
                <DisplayView view={view} setView={setView} className={''} />
                <div className='w-100 ml-4'>
                    <SearchSimple
                        id={'txt_d_search_simple'}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setSearchResults}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        search={search}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        searchElement={searchElement}
                        contractorId={null}
                        supplierId={null}
                        viewType={VIEW_TYPE.LIST.viewType}
                    />
                </div>
            </div>

            {searchResults?.content?.length > 0 ? (
                <>
                    <CustomExpandableTable
                        columns={columns}
                        rows={searchResults?.content}
                        checkbox={(DEV || permission?.includes(permissionObj?.WEB_FOODIE_ITEM_DELETE))}
                        renderExpandedRow={renderExpandedRow}
                        renderOptionsMenu={renderOptionsMenu}
                        onRowExpand={handleRowExpand}
                        selectedList={selectedList}
                        handleCheckboxChange={handleCheckboxChange}
                        handleDeleteAll={handleDeleteAll}
                    />
                    {pagination()}
                </>

            ) : (
                <NotInformation
                    card={true}
                    text={ t('you_have_not_created_any_meals_yet')}
                    showButton={((DEV || permission?.includes(permissionObj?.WEB_FOODIE_ITEM_CREATE)))}
                    buttonId={'btn_dt_link_create_meal'}
                    buttonUrl={routes.foodieDish.create}
                    buttonTrans={'create_new_meal'}
                    searchElement={searchElement}
                />
            )}
        </>
    );
};

export default DishesTable;
